import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useRefCallback } from '@tencent/glue-react-use';
import { useEffect, useMemo, useState } from 'react';
import { deepEqual } from '@co-hooks/util';
export var configToVal = function configToVal(cropSizeItem, imageValue) {
  var minWidth = cropSizeItem.minWidth,
    maxWidth = cropSizeItem.maxWidth,
    minHeight = cropSizeItem.minHeight,
    maxHeight = cropSizeItem.maxHeight;
  var naturalWidth = imageValue.width,
    naturalHeight = imageValue.height;
  var width = maxWidth;
  var height = maxHeight;
  if (minHeight !== maxHeight) {
    var shouldHeight = Math.floor(naturalHeight / (naturalWidth / width));
    if (shouldHeight >= minHeight && shouldHeight <= maxHeight) {
      height = shouldHeight;
    }
  }
  return {
    width: width,
    height: height,
    minWidth: minWidth,
    maxWidth: maxWidth,
    minHeight: minHeight,
    maxHeight: maxHeight
  };
};
var initCropSizeVal = {
  minWidth: 1,
  width: 1,
  maxWidth: 1,
  minHeight: 1,
  height: 1,
  maxHeight: 1
};
export var getUserScale = function getUserScale(cropSizeVal, scaleBase) {
  var max = Math.max(cropSizeVal.width, cropSizeVal.height);
  return scaleBase / max;
};
function calculateRatioFromTwoNumbers(a, b) {
  return b === 0 ? a : calculateRatioFromTwoNumbers(b, a % b);
}
export var useCropControl = function useCropControl(_ref) {
  var cropSizeConfig = _ref.cropSizeConfig,
    scaleBase = _ref.scaleBase,
    imageValue = _ref.imageValue,
    labelType = _ref.labelType,
    disableCropSizeConfig = _ref.disableCropSizeConfig;
  var _useState = useState(initCropSizeVal),
    _useState2 = _slicedToArray(_useState, 2),
    cropSizeVal = _useState2[0],
    setCropSizeVal = _useState2[1];
  var _useState3 = useState(0),
    _useState4 = _slicedToArray(_useState3, 2),
    cropSizeIndex = _useState4[0],
    setCropSizeIndex = _useState4[1];
  var _useState5 = useState(null),
    _useState6 = _slicedToArray(_useState5, 2),
    cropCurrSizeConfig = _useState6[0],
    setCropCurrSizeConfig = _useState6[1];
  var ctrlDatasource = useMemo(function () {
    return cropCurrSizeConfig ? cropCurrSizeConfig.map(function (_ref2, idx) {
      var minWidth = _ref2.minWidth,
        minHeight = _ref2.minHeight,
        maxHeight = _ref2.maxHeight,
        maxWidth = _ref2.maxWidth;
      var ratio = calculateRatioFromTwoNumbers(minWidth, minHeight);
      return {
        label: labelType === 'px' ? "".concat(minWidth, " * ").concat(minHeight, " px") : "".concat(minWidth / ratio, " : ").concat(minHeight / ratio),
        value: idx,
        disabled: !!disableCropSizeConfig.find(function (item) {
          return item.maxWidth === maxWidth && item.maxHeight === maxHeight && item.minHeight === minHeight && item.minWidth === minWidth;
        })
      };
    }) : [];
  }, [cropCurrSizeConfig, disableCropSizeConfig]);
  var onSizeListChange = useRefCallback(function (index) {
    setCropSizeIndex(index);
    var nextSize = cropCurrSizeConfig === null || cropCurrSizeConfig === void 0 ? void 0 : cropCurrSizeConfig[index];
    nextSize && setCropSizeVal(configToVal(nextSize, imageValue));
  });
  useEffect(function () {
    if (!cropSizeConfig.length) {
      return;
    }
    if (!deepEqual(cropSizeConfig, cropCurrSizeConfig)) {
      var cropSizeItem = cropSizeConfig[0];
      setCropSizeVal(configToVal(cropSizeItem, imageValue));
      setCropSizeIndex(0);
      setCropCurrSizeConfig(cropSizeConfig);
    }
  }, [cropSizeConfig]);
  var cropScale = useMemo(function () {
    return getUserScale({
      width: cropSizeVal.width,
      height: cropSizeVal.height
    }, scaleBase);
  }, [cropSizeVal, scaleBase]);
  return {
    cropScale: cropScale,
    cropSizeVal: cropSizeVal,
    cropSizeIndex: cropSizeIndex,
    ctrlDatasource: ctrlDatasource,
    setCropSizeVal: setCropSizeVal,
    onSizeListChange: onSizeListChange
  };
};